import React from 'react'

function HomepageTargetIcon() {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M32 16V21.3333" stroke="#3A7DE4" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M32 42.6667V48.0001" stroke="#3A7DE4" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M21.3333 32H16" stroke="#3A7DE4" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M48.0001 32H42.6667" stroke="#3A7DE4" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M31.9999 58.6666C46.7274 58.6666 58.6666 46.7274 58.6666 31.9999C58.6666 17.2723 46.7274 5.33325 31.9999 5.33325C17.2723 5.33325 5.33325 17.2723 5.33325 31.9999C5.33325 46.7274 17.2723 58.6666 31.9999 58.6666Z" stroke="#3A7DE4" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )
}

export { HomepageTargetIcon }